<div class="alert-viewport fixed top-3 right-3 sm:top-4 sm:right-4 z-[1050] flex flex-col items-end gap-2 pointer-events-none">
  @for (alert of alertService.alerts$ | async; track alert.id) {
    <div
      role="status"
      aria-live="polite"
      (click)="removeAlert(alert)"
      class="alert-card group pointer-events-auto relative flex w-auto min-w-[13.5rem] max-w-[22rem] items-center gap-3 overflow-hidden rounded-lg border px-3 py-2.5 text-left text-slate-100 shadow-lg backdrop-blur-md transition duration-150 ease-out cursor-pointer select-none"
      [ngClass]="alertCardClass(alert)"
      @fade>
      <!-- Status Icon Pill -->
      <div
        class="grid h-6 w-6 shrink-0 place-items-center rounded-full"
        [ngClass]="alertIconPillClass(alert)">
        <app-icon [fontSize]="'14px'" [size]="'3.5'" [classList]="'text-current font-semibold'" [icon]="alert.icon"></app-icon>
      </div>

      <!-- Message / Details -->
      <div class="flex-1 min-w-0 pr-0.5 flex flex-col justify-center">
        <span class="text-[13px] font-medium leading-snug text-slate-100 break-words" [innerHTML]="alert.title"></span>
        @if (alert.desc) {
          <span class="text-[11.5px] leading-tight text-slate-400 break-words mt-0.5" [innerHTML]="alert.desc"></span>
        }
      </div>

      <!-- Dismiss Button -->
      <button
        type="button"
        (click)="removeAlert(alert); $event.stopPropagation()"
        class="-mr-1 grid h-5 w-5 shrink-0 place-items-center rounded text-slate-400 opacity-70 transition hover:bg-white/10 hover:text-slate-200 hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-sky-400"
        aria-label="Dismiss alert">
        <app-icon [fontSize]="'14px'" [size]="'3.5'" [classList]="'text-current'" icon="mdi-close"></app-icon>
      </button>
    </div>
  }
</div>
